export default __webpack_public_path__ + "static/media/972.c523b691.png";